import request from "@/utils/request";

const api = {
  saveUserConfig: "/user/saveUserConfig",
  getUserConfig:"user/getUserConfig",
};

export default api;

export function saveUserConfig(data) {
  return request({
    url: api.saveUserConfig,
    method: "post",
    data,
  });
}
export function getUserConfig(data) {
  return request({
    url: api.getUserConfig,
    method: "post",
    data,
  });
}
